import React from 'react';
import styled from 'styled-components';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { deletePalette } from '../redux/paletteDbSlice';
import { deleteRelationUserPalette } from '../redux/relationUserPaletteDbSlice';
import { deleteRelationPaletteCardTemplate } from '../redux/relationPaletteCardTemplateDbSlice';
import useOnePaletteValue from '../hooks/useOnePaletteValue';
import useAllRUPIdsByPalette from '../hooks/useAllRUPIdsByPalette';
import useAllRPCIdsByPalette from '../hooks/useAllRPCIdsByPalette';

const DeleteTemplateDialogContent = styled(DialogContent)`
  overflow: hidden;
`

type DeletePaletteDialogProps = {
  open: boolean;
  onClose: () => void;
  id: string | undefined;
  updateOrder: (paletteId: string) => void;
  updateSelection: () => void;
}
const DeletePaletteDialog: React.FC<DeletePaletteDialogProps> = ({open, onClose, id, updateOrder, updateSelection}) => {
  const dispatch = useDispatch();
  const palette = useOnePaletteValue(id);
  const rupIds = useAllRUPIdsByPalette(id);
  const rpcIds = useAllRPCIdsByPalette(id);

  if (palette?.standard) onClose();

  const deletePaletteExe = () => {
    if (id) {
      updateOrder(id);
      dispatch(deletePalette({id: id}));
      rupIds.forEach(rupId => dispatch(deleteRelationUserPalette({id: rupId})));
      rpcIds.forEach(rpcId => dispatch(deleteRelationPaletteCardTemplate({id: rpcId})));
    }
    updateSelection();
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>このカテゴリーを削除します</DialogTitle>
      <DeleteTemplateDialogContent>
        { palette?.name }
      </DeleteTemplateDialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={() => deletePaletteExe()}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeletePaletteDialog;
